module.exports = __webpack_public_path__ + "img/bannerSecundaryMobile.62162963.png";